import React, { useState, useEffect, startTransition, useRef } from "react";
import {
  Box,
  Typography,
  Collapse,
  Avatar,
  Tooltip,
  Button,
  tooltipClasses,
  IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {
  Key,
  Report,
  ExpandMore,
  ExpandLess,
  Home,
  ArrowCircleLeft,
  ArrowCircleRight,
  PushPin,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { API, graphqlOperation } from "aws-amplify";
import { useDispatch, useSelector } from "react-redux";
import {
  collapse,
  display,
  displaySettings,
  expand,
  hide,
  SideBarOpts,
} from "../../redux/reducers/sidebar";
import { gst, nonGst } from "../../redux/reducers/gstStatus";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SwapHorizontalCircleSharpIcon from "@mui/icons-material/SwapHorizontalCircleSharp";
import { updateUserPreference } from "../../graphql/mutations";
import { settingsClose } from "../../redux/reducers/companySkipSave";
import { showWarningSnackbar } from "../snackBar/snakbar";
import { handleFreeze } from "../../utils/common";
import { useThemes } from "../Theme/theme";
import useControlledNavigation from "../../hooks/useControlledNavigation";
import Link from "../LinkTagComponent";
import {
  createUserPreference,
  getSideBarUserPreference,
  getUserPreference,
  listUserPreference,
} from "../../graphql";

const ExpandToolTip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    // backgroundColor: "#eb6a6a",
    color: "#fff",
  },
  [`& .${tooltipClasses.arrow}`]: {
    // color: "#2e858b",
  },
}));
const SlidbarBox = styled(Box)`
  position: fixed;
  left: 0px;
  z-index: 999;
  overflow: hidden;
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
  // box-shadow: inset 0 0 8px #055157;
  box-shadow: 6px 0px 8px rgba(0, 0, 0, 0.2);
  padding: 0px 0px;
  padding-top: 3px;
  padding-bottom: 3px;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.palette.primary.main};

  & .boxes {
    position: relative;
    width: ${({ isExpanded }) => (isExpanded ? "270px" : "50px")};
    height: 40px;
    -webkit-transition: width 0.2s linear;
    transition: width 0.2s linear;
  }

  & .boxes .icon_box {
    width: 50px;
    height: 40px;
    background-color: ${({ theme }) => theme.palette.primary.main};
    position: absolute;
    left: 0;
    z-index: 990;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & .boxes .SubNav_box {
    width: 30px;
    height: 45px;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 300px;
    left: 300px;
    z-index: 900;
    transform: translate(-250px, 0px);
    transition: transform 0.2s linear;
  }

  & .boxes .text_box {
    width: 220px;
    height: 40px;
    background-color: ${({ theme }) => theme.palette.primary.main};
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    left: 50px;
    z-index: 900;
    transform: translate(-250px, 0px);
    transition: transform 0.2s linear;
  }

  :hover .boxes {
    width: ${({ isExpanded }) => (isExpanded ? "270px" : "50px")};
  }
  .boxes:hover {
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
  .icon_box:hover {
    background-color: ${({ theme }) => theme.palette.secondary.main};
  }
  .boxes:hover .text_box {
    background-color: ${({ theme }) => theme.palette.secondary.main};
  }

  .boxes .text_box {
    transform: translate(0px, 0px);
  }

  .collapse_boxes {
    position: relative;
    width: 50px;
    height: 40px;
    box-sizing: border-box;
    -webkit-transition: width 0.2s linear;
    transition: width 0.2s linear;
  }
  .collapse_empty {
    width: 50px;
    height: 40px;
    position: absolute;
    left: 0;
    background-color: ${({ theme }) => theme.palette.primary.main};
    z-index: 890;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .collapse_text {
    width: 200px;
    height: 40px;
    position: absolute;
    left: 50px;
    padding-left: 10px;
    display: flex;
    align-items: center;
    z-index: 850;
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
  :hover .collapse_boxes {
    width: ${({ isExpanded }) => (isExpanded ? "270px" : "50px")};
  }
  :hover .collapse_text {
  }
  k .collapse_text:hover .submenu_text {
    color: #fff;
  }
`;
function Sidebar() {
  const { theme } = useThemes();
  const dispatch = useDispatch();

  // if (document.querySelectorAll('[id*="navigate"]').length !== 0) {
  //   localStorage.setItem("SideBarOpts", "true");
  //   dispatch(SideBarOpts(true));
  // }
  // if (document.querySelectorAll('[id*="navigate"]').length == 0) {
  //   dispatch(SideBarOpts(false));
  //   localStorage.setItem("SideBarOpts", "false");
  // }

  const navigate = useControlledNavigation();

  const location = useLocation();
  const [gstStatus, setGstStatus] = useState("");
  const [subMenuOpen, setSubMenuOpen] = useState("");
  const { gstStatusFlag } = useSelector((state) => state.gstStatusReducer);
  const { saveSkipStatus } = useSelector(
    (state) => state.companySipSaveReducer
  );
  const [state, setState] = useState({
    selectMenu: "",
    selectSubMenu: "",
    openMenu: {
      dashboard: false,
      inventory: false,
      customer: false,
      purchase: false,
      sales: false,
      payments: false,
      receipts: false,
      accounts: false,
      reports: false,
      journalentries: false,
    },
  });
  const [selector, setselector] = useState("");
  const selectorIcon = (req) => {
    if (window.location.href.indexOf(req) > 0 && req !== "/") {
      return true;
    } else if (window.location.pathname === req) {
      return true;
    } else {
      return false;
    }
  };
  let getCompany = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );

  async function getCompanyDetails() {
    try {
      setGstStatus(getCompany?.relatedcompanydetailsnew?.[0].registrationtype);
    } catch (error) {
      console.log("error", error);
    }
  }

  useEffect(() => {
    getCompanyDetails();
  }, [gstStatusFlag]);

  const Freeze = useSelector(
    (state) => state.userPrefrenceandReducer?.financialYear?.freezestatus
  );

  const menuStyle ={
          color: "#911B7C",
            fontSize: "12px",
            fontWeight: "bold",
            // backgroundColor: selectorIcon("/") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
            boxShadow: selectorIcon("/")
              ? ""
              : "0px 6px 8px rgba(0, 0, 0, 0.5)",
            backgroundColor: "#ffff",
            borderRadius: "3px",
            height: "30px",
            width: "30px",
  }

  const cousColor = "#13fd84ff";
  const supColor = "#dcb103d0";
  const dbnColor = "#1576f4ff";
  const jvColor = "#BA68C8"
  const menus = [
    {
      menu: 'dashboard',
      title: 'Dashboard',
      mainNav: '/?active=Business_Overview',
      tooltip: '',
      toolTipMain: '',
      // icon: <Avatar variant="rounded" sx={{ color: state.openMenu.dashboard && (state.selectMenu == 'dashboard') ? '#ffffff' : '#ffffff', fontSize: '12px', fontWeight: 'bold', backgroundColor: 'rgb(255 255 255 / 20%)', borderRadius: '3px', height: '30px', width: '30px' }}>DaB</Avatar>,
      icon: (
        <Avatar
          variant="rounded"
          sx={{
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: 'bold',
            // backgroundColor: selectorIcon("/") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
            boxShadow: selectorIcon('/') ? '' : '0px 6px 8px rgba(0, 0, 0, 0.5)',
            backgroundColor: 'rgb(255 255 255 / 20%)',
            borderRadius: '3px',
            height: '30px',
            width: '30px',
          }}
          // sx={menuStyle}
        >
          DaB
        </Avatar>
      ),
      submenuColor:theme.palette.secondary.main,
      submenus: [],
      nav: '/?active=Business_Overview',
    },
    {
      menu: 'inventory',
      title: 'Inventory & Items',
      mainNav: '/newItemList',
      subNav: '/additem',
      subNavDisabled: Freeze,
      tooltip: 'Add Item',
      toolTipMain: 'View Item List',
      icon: (
        <Avatar
          variant="rounded"
          sx={{
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: 'bold',
            // backgroundColor: selectorIcon("goods") || selectorIcon("service") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
            boxShadow: selectorIcon('newItem') || selectorIcon('additem') ? '' : '0px 6px 8px rgba(0, 0, 0, 0.5)',
            backgroundColor: 'rgb(255 255 255 / 20%)',
            borderRadius: '3px',
            height: '30px',
            width: '30px',
          }}
          // sx={menuStyle}
        >
          Itm
        </Avatar>
      ),
      submenuColor:theme.palette.secondary.main,
      submenus: [],
    },
    {
      menu: 'customer',
      title: 'Customer',
      mainNav: '/customerList',
      subNav: '/addcustomer',
      subNavDisabled: Freeze,
      tooltip: 'Add Customer',
      toolTipMain: 'View Customer List',
      icon: (
        <Avatar
          variant="rounded"
          sx={{
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: 'bold',
            //  backgroundColor: selectorIcon('customer') ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
            boxShadow: selectorIcon('customer') ? '' : '0px 6px 8px rgba(0, 0, 0, 0.5)',
            backgroundColor: 'rgb(255 255 255 / 20%)',
            borderRadius: '3px',
            height: '30px',
            width: '30px',
          }}
          // sx={menuStyle}
        >
          Cus
        </Avatar>
      ),
      submenus: [],
      submenuColor:cousColor,
    },
    {
      menu: 'Sales Invoices',
      title: 'Sales Invoices',
      mainNav: '/salesInvoiceReport',
      subNav:
        // gstStatus == 1 ? "/addinvoiceNonTaxable" : "/addinvoiceTaxable",
        '/addnewinvoicetax',
      subNavDisabled: Freeze,
      toolTipMain: 'View Sales Invoice List',
      tooltip: 'Add Invoice',
      icon: (
        <Avatar
          variant="rounded"
          sx={{
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: 'bold',
            // backgroundColor: selectorIcon('supplier') ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
            boxShadow:
              (selectorIcon('sales') || selectorIcon('invoice')) && !selectorIcon('active=pos') ? '' : '0px 6px 8px rgba(0, 0, 0, 0.5)',
            backgroundColor: 'rgb(255 255 255 / 20%)',
            borderRadius: '3px',
            height: '30px',
            width: '30px',
          }}
        >
          Sinv
        </Avatar>
      ),
      submenus: [],
      submenuColor:cousColor,
    },
    {
      menu: 'POS',
      title: 'POS',
      mainNav: '/allpos',
      subNav: '/newpos',
      subNavDisabled: Freeze,
      toolTipMain: 'View POS Invoice List',
      tooltip: 'Add Pos',
      icon: (
        <Avatar
          variant="rounded"
          sx={{
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: 'bold',
            // backgroundColor: selectorIcon('supplier') ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
            boxShadow: selectorIcon('pos') ? '' : '0px 6px 8px rgba(0, 0, 0, 0.5)',
            backgroundColor: 'rgb(255 255 255 / 20%)',
            borderRadius: '3px',
            height: '30px',
            width: '30px',
          }}
          // sx={menuStyle}
        >
          Pos
        </Avatar>
      ),
      submenus: [],
       submenuColor:cousColor,
    },
    {
      menu: 'receipts',
      title: 'Receipts',
      mainNav: '/receipts',
      subNav: '/addreceipts',
      subNavDisabled: Freeze,
      tooltip: 'Add Receipts',
      toolTipMain: 'View Receipt List',
      icon: (
        <Avatar
          variant="rounded"
          sx={{
            color: '#ffff',
            fontSize: '12px',
            fontWeight: 'bold',
            // backgroundColor: selectorIcon("receipts") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
            boxShadow: selectorIcon('receipts') ? '' : '0px 6px 8px rgba(0, 0, 0, 0.5)',
            backgroundColor: 'rgb(255 255 255 / 20%)',
            borderRadius: '3px',
            height: '30px',
            width: '30px',
          }}
        >
          Rec
        </Avatar>
      ),
      submenus: [
        // {
        //   name: 'Receipts',
        //   nav: '/receipts'
        // },
        // {
        //   name: 'Add Receipts',
        //   nav: '/addreceipts'
        // },
      ],
       submenuColor:cousColor,
    },
    {
      menu: 'supplier',
      title: 'Supplier',
      mainNav: '/supplierList',
      subNav: '/addsupplier',
      subNavDisabled: Freeze,
      tooltip: 'Add Supplier',
      toolTipMain: 'View Supplier List',
      icon: (
        <Avatar
          variant="rounded"
          sx={{
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: 'bold',
            // backgroundColor: selectorIcon('supplier') ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
            boxShadow: selectorIcon('supplier') ? '' : '0px 6px 8px rgba(0, 0, 0, 0.5)',
            backgroundColor: 'rgb(255 255 255 / 20%)',
            borderRadius: '3px',
            height: '30px',
            width: '30px',
          }}
          // sx={menuStyle}
        >
          Sup
        </Avatar>
      ),
      submenus: [],
      submenuColor:supColor,
    },

    {
      menu: 'Purchase Invoices',
      title: 'Purchase Invoices',
      mainNav: '/allpurchaseandexpense',
      subNav:
        // gstStatus == 1
        //   ? "/addpurchaseandexpensenontaxable"
        //   : "/addpurchaseandexpensetaxable",
        '/addnewpurchasetax',
      subNavDisabled: Freeze,
      toolTipMain: 'View Purchase Invoice List',
      tooltip: 'Add Purchase Invoice',
      icon: (
        <Avatar
          variant="rounded"
          sx={{
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: 'bold',
            // backgroundColor: selectorIcon('purchase') || selectorIcon("debit") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
            boxShadow: selectorIcon('purchase') ? '' : '0px 6px 8px rgba(0, 0, 0, 0.5)',
            backgroundColor: 'rgb(255 255 255 / 20%)',
            borderRadius: '3px',
            height: '30px',
            width: '30px',
          }}
        >
          Pinv
        </Avatar>
      ),
      submenus: [],
      submenuColor:supColor,
    },

    {
      menu: 'payments',
      title: 'Payments',
      mainNav: '/paymententries',
      subNav: '/addpaymententries',
      subNavDisabled: Freeze,
      tooltip: 'Add Payment',
      toolTipMain: 'View Payment List',
      icon: (
        <Avatar
          variant="rounded"
          sx={{
            color: '#ffff',
            fontSize: '12px',
            fontWeight: 'bold',
            // backgroundColor: selectorIcon("payment") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
            boxShadow: selectorIcon('payment') ? '' : '0px 6px 8px rgba(0, 0, 0, 0.5)',
            backgroundColor: 'rgb(255 255 255 / 20%)',
            borderRadius: '3px',
            height: '30px',
            width: '30px',
          }}
          // sx={menuStyle}
        >
          Pay
        </Avatar>
      ),
      submenus: [
        // {
        //   name: 'Payment Entries',
        //   nav: '/paymententries'
        // },
        // {
        //   name: 'Add Payment Entries',
        //   nav: '/addpaymententries'
        // },
      ],
      submenuColor:supColor,
    },
    {
      menu: 'Debit Note /Purchase Return',
      title: 'Debit Note',
      mainNav: '/alldebitnote',
      subNav: '/adddebitnote',
      subNavDisabled: Freeze,
      tooltip: 'Add Debit Note',
      toolTipMain: 'View Debit Note List',
      icon: (
        <Avatar
          variant="rounded"
          sx={{
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: 'bold',
            // backgroundColor: selectorIcon("goods") || selectorIcon("service") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
            boxShadow: selectorIcon('debit') ? '' : '0px 6px 8px rgba(0, 0, 0, 0.5)',
            backgroundColor: 'rgb(255 255 255 / 20%)',
            borderRadius: '3px',
            height: '30px',
            width: '30px',
          }}
          // sx={menuStyle}
        >
          Drn
        </Avatar>
      ),
      submenus: [],
      submenuColor:dbnColor,
    },

    {
      menu: 'Credit Note / Sales Return',
      title: 'Credit Note',
      mainNav: '/allcreditnote',
      subNav: '/addcreditnote',
      subNavDisabled: Freeze,
      tooltip: 'Add Credit Note',
      toolTipMain: 'View Credit Note List',
      icon: (
        <Avatar
          variant="rounded"
          sx={{
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: 'bold',
            // backgroundColor: selectorIcon("goods") || selectorIcon("service") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
            boxShadow: selectorIcon('credit') ? '' : '0px 6px 8px rgba(0, 0, 0, 0.5)',
            backgroundColor: 'rgb(255 255 255 / 20%)',
            borderRadius: '3px',
            height: '30px',
            width: '30px',
          }}
          // sx={menuStyle}
        >
          Crn
        </Avatar>
      ),
      submenus: [],
      submenuColor:dbnColor,
    },
    // {
    //   menu: "Debit/Credit",
    //   title: "Debit/Credit",
    //   // mainNav: "/alldebitnote",
    //   // subNav: gstStatus !== 1 ? '/addpurchaseandexpensetaxable' : '/addpurchaseandexpensenontaxable',
    //   tooltip: "Add Purchase",
    //   // toolTipMain: "View Purchase List",
    //   // newTab: true,
    //   icon: (
    //     <Avatar
    //       variant="rounded"
    //       sx={{
    //         color: "#ffffff",
    //         fontSize: "12px",
    //         fontWeight: "bold",
    //         // backgroundColor: selectorIcon('purchase') || selectorIcon("debit") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
    //         boxShadow:
    //           selectorIcon("credit") || selectorIcon("debit")
    //             ? ""
    //             : "0px 6px 8px rgba(0, 0, 0, 0.5)",
    //         backgroundColor: "rgb(255 255 255 / 20%)",
    //         borderRadius: "3px",
    //         height: "30px",
    //         width: "30px",
    //       }}
    //     >
    //       DCN
    //     </Avatar>
    //   ),
    //   submenus: [
    //     {
    //       name: "Debit Note /Purchase Return",
    //       nav: "/alldebitnote",
    //       subNav: "/adddebitnote",
    //       subNavDisabled: Freeze,
    //       tab: true,
    //       tooltipMain: "View Debit Note List",
    //       tooltip: "Add Debit Note",
    //       icon: (
    //         <Avatar
    //           variant="rounded"
    //           sx={{
    //             background: theme.palette.secondary.main,
    //             color: "white",
    //             fontSize: "10px",
    //             fontWeight: "bold",
    //             borderRadius: "3px",
    //             height: "25px",
    //             width: "25px",
    //           }}
    //         >
    //           DrN
    //         </Avatar>
    //       ),
    //     },
    //     {
    //       name: "Credit Note / Sales Return",
    //       nav: "/allcreditnote",
    //       subNav: "/addcreditnote",
    //       subNavDisabled: Freeze,
    //       tab: true,
    //       tooltipMain: "View Credit Note List",
    //       tooltip: "Add Credit Note",
    //       icon: (
    //         <Avatar
    //           variant="rounded"
    //           sx={{
    //             background: theme.palette.secondary.main,
    //             color: "white",
    //             fontSize: "10px",
    //             fontWeight: "bold",
    //             borderRadius: "3px",
    //             height: "25px",
    //             width: "25px",
    //           }}
    //         >
    //           CrN
    //         </Avatar>
    //       ),
    //     },
    //   ],
    // },

    {
      menu: 'Journal Entries',
      title: 'Journal Entries',
      mainNav: '/journalentries',
      subNav: '/addjournalentry',
      subNavDisabled: Freeze,
      tooltip: 'Add Journal Entries',
      toolTipMain: 'View Journal Entries List',
      icon: (
        <Avatar
          variant="rounded"
          sx={{
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: 'bold',
            // backgroundColor: selectorIcon("goods") || selectorIcon("service") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
            boxShadow: selectorIcon('journal') ? '' : '0px 6px 8px rgba(0, 0, 0, 0.5)',
            backgroundColor: 'rgb(255 255 255 / 20%)',
            borderRadius: '3px',
            height: '30px',
            width: '30px',
          }}
          // sx={menuStyle}
        >
          JV
        </Avatar>
      ),
      submenus: [],
      submenuColor:jvColor,
    },

    {
      menu: 'Opening Balance',
      title: 'Opening Balance',
      mainNav: '/openingbalance',
      subNav: '/openingbalance',
      subNavDisabled: Freeze,
      tooltip: 'Add Opening Balance',
      toolTipMain: 'View Opening Balance List',
      icon: (
        <Avatar
          variant="rounded"
          sx={{
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: 'bold',
            // backgroundColor: selectorIcon("goods") || selectorIcon("service") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
            boxShadow: selectorIcon('openingbalance') ? '' : '0px 6px 8px rgba(0, 0, 0, 0.5)',
            backgroundColor: 'rgb(255 255 255 / 20%)',
            borderRadius: '3px',
            height: '30px',
            width: '30px',
          }}
          // sx={menuStyle}
        >
          OpB
        </Avatar>
      ),
      submenus: [],
      submenuColor:jvColor,
    },
    // {
    //   menu: "Others",
    //   title: "Others",
    //   // mainNav: null,
    //   // subNav: gstStatus !== 1 ? '/addpurchaseandexpensetaxable' : '/addpurchaseandexpensenontaxable',
    //   tooltip: "Add Purchase",
    //   // toolTipMain: "View Purchase List",
    //   // newTab: true,
    //   icon: (
    //     <Avatar
    //       variant="rounded"
    //       sx={{
    //         color: "#ffffff",
    //         fontSize: "12px",
    //         fontWeight: "bold",
    //         // backgroundColor: selectorIcon('purchase') || selectorIcon("debit") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
    //         boxShadow:
    //           selectorIcon("journalentries") || selectorIcon("openingbalance")
    //             ? ""
    //             : "0px 6px 8px rgba(0, 0, 0, 0.5)",
    //         backgroundColor: "rgb(255 255 255 / 20%)",
    //         borderRadius: "3px",
    //         height: "30px",
    //         width: "30px",
    //       }}
    //     >
    //       Oth
    //     </Avatar>
    //   ),
    //   submenus: [
    //     {
    //       name: "Journal Entries",
    //       nav: "/journalentries",
    //       subNav: "/addjournalentry",
    //       subNavDisabled: Freeze,
    //       tab: true,
    //       tooltipMain: "View Journal Entries",
    //       tooltip: "Add Journal Entries",
    //       icon: (
    //         <Avatar
    //           variant="rounded"
    //           sx={{
    //             background: theme.palette.secondary.main,
    //             color: "white",
    //             fontSize: "10px",
    //             fontWeight: "bold",
    //             borderRadius: "3px",
    //             height: "25px",
    //             width: "25px",
    //           }}
    //         >
    //           JV
    //         </Avatar>
    //       ),
    //     },
    //     {
    //       name: "Opening Balance",
    //       nav: "/openingbalance",
    //       subNav: "/openingbalance",
    //       subNavDisabled: Freeze,
    //       tab: true,
    //       tooltipMain: "View Opening Balance List",
    //       tooltip: "Opening Balance",
    //       icon: (
    //         <Avatar
    //           variant="rounded"
    //           sx={{
    //             background: theme.palette.secondary.main,
    //             color: "white",
    //             fontSize: "10px",
    //             fontWeight: "bold",
    //             borderRadius: "3px",
    //             height: "25px",
    //             width: "25px",
    //           }}
    //         >
    //           OpB
    //         </Avatar>
    //       ),
    //     },
    //     // {
    //     //   name: "Accounts",
    //     //   nav: "/accounts",
    //     //   // subNav: "nnn",
    //     //   tab: true,
    //     //   tooltipMain: "View Accounts",
    //     //   tooltip: "Accounts",
    //     //   icon: (
    //     //     <Avatar
    //     //       variant="rounded"
    //     //       sx={{
    //     //         background: theme.palette.secondary.main,
    //     //         color: "white",
    //     //         fontSize: "10px",
    //     //         fontWeight: "bold",
    //     //         borderRadius: "3px",
    //     //         height: "25px",
    //     //         width: "25px",
    //     //       }}
    //     //     >
    //     //       Acc
    //     //     </Avatar>
    //     //   ),
    //     // },
    //   ],
    // },
    {
      menu: 'accounts',
      title: 'Accounts',
      mainNav: '/accounts',
      toolTipMain: 'View Accounts ',
      // subNav: '',
      tooltip: '',
      icon: (
        <Avatar
          variant="rounded"
          sx={{
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: 'bold',
            // backgroundColor: selectorIcon("accounts") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
            boxShadow: selectorIcon('accounts') || selectorIcon('groups') ? '' : '0px 6px 8px rgba(0, 0, 0, 0.5)',
            backgroundColor: 'rgb(255 255 255 / 20%)',
            borderRadius: '3px',
            height: '30px',
            width: '30px',
          }}
          // sx={menuStyle}
        >
          Acc
        </Avatar>
      ),
      submenus: [],
      submenuColor:jvColor,
    },
    {
      menu: 'reports',
      title: 'Reports',
      mainNav: '/reports',
      // subNav: '',
      tooltip: '',
      toolTipMain: 'View Reports',
      icon: (
        <Avatar
          variant="rounded"
          sx={{
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: 'bold',
            // backgroundColor: selectorIcon("reports") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
            boxShadow: selectorIcon('reports') ? '' : '0px 6px 8px rgba(0, 0, 0, 0.5)',
            backgroundColor: 'rgb(255 255 255 / 20%)',
            borderRadius: '3px',
            height: '30px',
            width: '30px',
          }}
          // sx={menuStyle}
        >
          Rpt
        </Avatar>
      ),
      submenus: [],
      submenuColor:jvColor,
    },
  ];

  // const menus = [
  //   {
  //     menu: "dashboard",
  //     title: "Dashboard",
  //     mainNav: "/",
  //     tooltip: "",
  //     toolTipMain: "",
  //     // icon: <Avatar variant="rounded" sx={{ color: state.openMenu.dashboard && (state.selectMenu == 'dashboard') ? '#ffffff' : '#ffffff', fontSize: '12px', fontWeight: 'bold', backgroundColor: 'rgb(255 255 255 / 20%)', borderRadius: '3px', height: '30px', width: '30px' }}>DaB</Avatar>,
  //     icon: (
  //       <Avatar
  //         variant="rounded"
  //         sx={{
  //           color: selectorIcon("dashboard") ? "sideBar.secondary" : "#ffffff",
  //           fontSize: "12px",
  //           fontWeight: "bold",
  //           // backgroundColor: selectorIcon("/") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
  //           boxShadow: selectorIcon("/")
  //             ? ""
  //             : "0px 6px 8px rgba(0, 0, 0, 0.5)",
  //           backgroundColor: "rgb(255 255 255 / 20%)",
  //           borderRadius: "3px",
  //           height: "30px",
  //           width: "30px",
  //         }}
  //       >
  //         DaB
  //       </Avatar>
  //     ),
  //     submenus: [],
  //     nav: "/",
  //   },
  //   {
  //     menu: "inventory",
  //     title: "Inventory & Items",
  //     mainNav: "/AddItem",
  //     subNav: "/AddItemView",
  //     tooltip: "Add Item",
  //     toolTipMain: "View Item List",
  //     icon: (
  //       <Avatar
  //         variant="rounded"
  //         sx={{
  //           color: selectorIcon("inventory") ? "sideBar.secondary" : "#ffffff",
  //           fontSize: "12px",
  //           fontWeight: "bold",
  //           // backgroundColor: selectorIcon("goods") || selectorIcon("service") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
  //           boxShadow: selectorIcon("AddItem")
  //             ? ""
  //             : "0px 6px 8px rgba(0, 0, 0, 0.5)",
  //           backgroundColor: "rgb(255 255 255 / 20%)",
  //           borderRadius: "3px",
  //           height: "30px",
  //           width: "30px",
  //         }}
  //       >
  //         Itm
  //       </Avatar>
  //     ),
  //     submenus: [],
  //   },
  //   {
  //     menu: "customer",
  //     title: "Customer",
  //     mainNav: "/customerList",
  //     subNav: "/addcustomer",
  //     tooltip: "Add Customer",
  //     toolTipMain: "View Customer List",
  //     icon: (
  //       <Avatar
  //         variant="rounded"
  //         sx={{
  //           color: selectorIcon("customer") ? "sideBar.secondary" : "#ffffff",
  //           fontSize: "12px",
  //           fontWeight: "bold",
  //           //  backgroundColor: selectorIcon('customer') ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
  //           boxShadow: selectorIcon("customer")
  //             ? ""
  //             : "0px 6px 8px rgba(0, 0, 0, 0.5)",
  //           backgroundColor: "rgb(255 255 255 / 20%)",
  //           borderRadius: "3px",
  //           height: "30px",
  //           width: "30px",
  //         }}
  //       >
  //         Cus
  //       </Avatar>
  //     ),
  //     submenus: [],
  //   },
  //   {
  //     menu: "supplier",
  //     title: "Supplier",
  //     mainNav: "/supplierList",
  //     subNav: "/addsupplier",
  //     tooltip: "Add Supplier",
  //     toolTipMain: "View Supplier List",
  //     icon: (
  //       <Avatar
  //         variant="rounded"
  //         sx={{
  //           color: selectorIcon("customer") ? "sideBar.secondary" : "#ffffff",
  //           fontSize: "12px",
  //           fontWeight: "bold",
  //           // backgroundColor: selectorIcon('supplier') ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
  //           boxShadow: selectorIcon("supplier")
  //             ? ""
  //             : "0px 6px 8px rgba(0, 0, 0, 0.5)",
  //           backgroundColor: "rgb(255 255 255 / 20%)",
  //           borderRadius: "3px",
  //           height: "30px",
  //           width: "30px",
  //         }}
  //       >
  //         Sup
  //       </Avatar>
  //     ),
  //     submenus: [],
  //   },
  //   {
  //     menu: "purchase",
  //     title: "Purchase / Expense",
  //     mainNav: "/allpurchaseandexpense",
  //     // subNav: gstStatus !== 1 ? '/addpurchaseandexpensetaxable' : '/addpurchaseandexpensenontaxable',
  //     tooltip: "Add Purchase",
  //     toolTipMain: "View Purchase List",
  //     // newTab: true,
  //     icon: (
  //       <Avatar
  //         variant="rounded"
  //         sx={{
  //           color: selector === "purchase" ? "sideBar.secondary" : "#ffffff",
  //           fontSize: "12px",
  //           fontWeight: "bold",
  //           // backgroundColor: selectorIcon('purchase') || selectorIcon("debit") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
  //           boxShadow:
  //             selectorIcon("purchase") || selectorIcon("debit")
  //               ? ""
  //               : "0px 6px 8px rgba(0, 0, 0, 0.5)",
  //           backgroundColor: "rgb(255 255 255 / 20%)",
  //           borderRadius: "3px",
  //           height: "30px",
  //           width: "30px",
  //         }}
  //       >
  //         Pur
  //       </Avatar>
  //     ),
  //     submenus: [
  //       // {
  //       //   name: 'Purchase & Expense',
  //       //   nav: '/allpurchaseandexpense'
  //       // },
  //       // {
  //       //   name: 'Add Purchase & Expense',
  //       //   nav: gstStatus==1?'/addpurchaseandexpensenontaxable':'/addpurchaseandexpensetaxable',
  //       //   tab: true
  //       // },
  //       {
  //         name: "Purchase Invoices",
  //         nav: "/allpurchaseandexpense",
  //         subNav:
  //           // gstStatus == 1
  //           //   ? "/addpurchaseandexpensenontaxable"
  //           //   : "/addpurchaseandexpensetaxable",
  //           "/addnewpurchasetax",
  //         tab: true,
  //         tooltipMain: "View Purchase Invoice List",
  //         tooltip: "Add Purchase Invoice",
  //         icon: (
  //           <Avatar
  //             variant="rounded"
  //             sx={{
  //               background: theme.palette.secondary.main,
  //               color: "white",
  //               fontSize: "10px",
  //               fontWeight: "bold",
  //               borderRadius: "3px",
  //               height: "25px",
  //               width: "25px",
  //             }}
  //           >
  //             Inv
  //           </Avatar>
  //         ),
  //       },
  //       {
  //         name: "Debit Note / Purchase Return",
  //         nav: "/alldebitnote",
  //         subNav: "/adddebitnote",
  //         tab: true,
  //         tooltipMain: "View Debit Note List",
  //         tooltip: "Add Debit Note",
  //         icon: (
  //           <Avatar
  //             variant="rounded"
  //             sx={{
  //               background: theme.palette.secondary.main,
  //               color: "white",
  //               fontSize: "10px",
  //               fontWeight: "bold",
  //               borderRadius: "3px",
  //               height: "25px",
  //               width: "25px",
  //             }}
  //           >
  //             DrN
  //           </Avatar>
  //         ),
  //       },
  //     ],
  //   },
  //   {
  //     menu: "sales",
  //     title: "Sales / Income",
  //     mainNav: "/salesInvoiceReport",
  //     // subNav: gstStatus==1 || gstStatus==3?'/addinvoiceNonTaxable':'/addinvoiceTaxable',
  //     tooltip: "Add Invoice",
  //     toolTipMain: "View Sales List",
  //     // newTab: true,
  //     icon: (
  //       <Avatar
  //         variant="rounded"
  //         sx={{
  //           color: selector === "sales" ? "sideBar.secondary" : "#ffffff",
  //           fontSize: "12px",
  //           fontWeight: "bold",
  //           //  backgroundColor: selectorIcon("sales") || selectorIcon("invoice") || selectorIcon("pos") || selectorIcon("credit") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
  //           boxShadow:
  //             selectorIcon("sales") ||
  //               selectorIcon("invoice") ||
  //               selectorIcon("pos") ||
  //               selectorIcon("credit")
  //               ? ""
  //               : "0px 6px 8px rgba(0, 0, 0, 0.5)",
  //           backgroundColor: "rgb(255 255 255 / 20%)",
  //           borderRadius: "3px",
  //           height: "30px",
  //           width: "30px",
  //         }}
  //       >
  //         Sle
  //       </Avatar>
  //     ),
  //     submenus: [
  //       {
  //         name: "Sales Invoices",
  //         nav: "/salesInvoiceReport",
  //         subNav:
  //           // gstStatus == 1 ? "/addinvoiceNonTaxable" : "/addinvoiceTaxable",
  //           "/addnewinvoicetax",
  //         tab: true,
  //         tooltipMain: "View Sales Invoice List",
  //         tooltip: "Add Invoice",
  //         icon: (
  //           <Avatar
  //             variant="rounded"
  //             sx={{
  //               background: theme.palette.secondary.main,
  //               color: "white",
  //               fontSize: "10px",
  //               fontWeight: "bold",
  //               borderRadius: "3px",
  //               height: "25px",
  //               width: "25px",
  //             }}
  //           >
  //             Sal
  //           </Avatar>
  //         ),
  //       },
  //       {
  //         name: "POS",
  //         nav: "/salesInvoiceReport?active=pos",
  //         subNav: "/newpos",
  //         tab: true,
  //         tooltipMain: "View POS List",
  //         tooltip: "Add Pos",
  //         icon: (
  //           <Avatar
  //             variant="rounded"
  //             sx={{
  //               background: theme.palette.secondary.main,
  //               color: "white",
  //               fontSize: "10px",
  //               fontWeight: "bold",
  //               borderRadius: "3px",
  //               height: "25px",
  //               width: "25px",
  //             }}
  //           >
  //             Pos
  //           </Avatar>
  //         ),
  //       },
  //       {
  //         name: "Recurring Invoices",
  //         // nav: '/addrecurringinvoice',
  //         // subNav: '/addrecurringinvoice',
  //         tab: true,
  //         tooltipMain: "View Recurring Invoice List",
  //         tooltip: "Add Recurring Invoices",
  //         icon: (
  //           <Avatar
  //             variant="rounded"
  //             sx={{
  //               // background: theme.palette.secondary.main,
  //               background: "#b5b5b5",
  //               color: "white",
  //               fontSize: "10px",
  //               fontWeight: "bold",
  //               borderRadius: "3px",
  //               height: "25px",
  //               width: "25px",
  //             }}
  //           >
  //             RI
  //           </Avatar>
  //         ),
  //       },

  //       {
  //         name: "Credit Note / Sales Return",
  //         nav: "/allcreditnote",
  //         subNav: "/addcreditnote",
  //         tab: true,
  //         tooltipMain: "View Credit Note List",
  //         tooltip: "Add Credit Note",
  //         icon: (
  //           <Avatar
  //             variant="rounded"
  //             sx={{
  //               background: theme.palette.secondary.main,
  //               color: "white",
  //               fontSize: "10px",
  //               fontWeight: "bold",
  //               borderRadius: "3px",
  //               height: "25px",
  //               width: "25px",
  //             }}
  //           >
  //             CrN
  //           </Avatar>
  //         ),
  //       },
  //     ],
  //   },
  //   // {
  //   //   menu: 'reccurringInvoice',
  //   //   title: 'Recurring Invoice',
  //   //   mainNav: '/addrecurringinvoice',
  //   //   subNav: '',
  //   //   tooltip: 'Add Recurring Invoice',
  //   //   toolTipMain:"View Recurring Invoice List",
  //   //   icon: <Avatar variant="rounded" sx={{ color: state.openMenu.reccurringInvoice && (state.selectMenu == 'customer') ? '#ffffff' : '#ffffff', fontSize: '12px',   fontWeight: 'bold',  backgroundColor: 'rgb(255 255 255 / 20%)', borderRadius: '3px', height: '30px',  width: '30px'}}>RInv</Avatar>,
  //   //   submenus: [
  //   //   ]
  //   // },
  //   {
  //     menu: "payments",
  //     title: "Payments",
  //     mainNav: "/paymententries",
  //     subNav: "/addpaymententries",
  //     tooltip: "Add Payment Entries",
  //     toolTipMain: "View Payment Entry List",
  //     icon: (
  //       <Avatar
  //         variant="rounded"
  //         sx={{
  //           color: selectorIcon("payments") ? "sideBar.secondary" : "#ffffff",
  //           fontSize: "12px",
  //           fontWeight: "bold",
  //           // backgroundColor: selectorIcon("payment") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
  //           boxShadow: selectorIcon("payment")
  //             ? ""
  //             : "0px 6px 8px rgba(0, 0, 0, 0.5)",
  //           backgroundColor: "rgb(255 255 255 / 20%)",
  //           borderRadius: "3px",
  //           height: "30px",
  //           width: "30px",
  //         }}
  //       >
  //         Pay
  //       </Avatar>
  //     ),
  //     submenus: [
  //       // {
  //       //   name: 'Payment Entries',
  //       //   nav: '/paymententries'
  //       // },
  //       // {
  //       //   name: 'Add Payment Entries',
  //       //   nav: '/addpaymententries'
  //       // },
  //     ],
  //   },
  //   {
  //     menu: "receipts",
  //     title: "Receipts",
  //     mainNav: "/receipts",
  //     subNav: "/addreceipts",
  //     tooltip: "Add Receipts",
  //     toolTipMain: "View Receipt List",
  //     icon: (
  //       <Avatar
  //         variant="rounded"
  //         sx={{
  //           color: selector == "receipts" ? "sideBar.secondary" : "#ffffff",
  //           fontSize: "12px",
  //           fontWeight: "bold",
  //           // backgroundColor: selectorIcon("receipts") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
  //           boxShadow: selectorIcon("receipts")
  //             ? ""
  //             : "0px 6px 8px rgba(0, 0, 0, 0.5)",
  //           backgroundColor: "rgb(255 255 255 / 20%)",
  //           borderRadius: "3px",
  //           height: "30px",
  //           width: "30px",
  //         }}
  //       >
  //         Rec
  //       </Avatar>
  //     ),
  //     submenus: [
  //       // {
  //       //   name: 'Receipts',
  //       //   nav: '/receipts'
  //       // },
  //       // {
  //       //   name: 'Add Receipts',
  //       //   nav: '/addreceipts'
  //       // },
  //     ],
  //   },
  //   {
  //     menu: "journalentries",
  //     title: "Journal Entries",
  //     mainNav: "/journalentries",
  //     subNav: "/addjournalentry",
  //     tooltip: "Add Journal Entries",
  //     toolTipMain: "View Joutnal Entries",
  //     icon: (
  //       <Avatar
  //         variant="rounded"
  //         sx={{
  //           color:
  //             selector == "journalentries" ? "sideBar.secondary" : "#ffffff",
  //           fontSize: "12px",
  //           fontWeight: "bold",
  //           //  backgroundColor: selectorIcon("journalentries") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
  //           boxShadow: selectorIcon("journalentries")
  //             ? ""
  //             : "0px 6px 8px rgba(0, 0, 0, 0.5)",
  //           backgroundColor: "rgb(255 255 255 / 20%)",
  //           borderRadius: "3px",
  //           height: "30px",
  //           width: "30px",
  //         }}
  //       >
  //         Jrl
  //       </Avatar>
  //     ),
  //     submenus: [
  //       // {
  //       //   name: 'All journal entries',
  //       //   nav: '/journalentries'
  //       // },
  //       // {
  //       //   name: 'Add journal entries',
  //       //   nav: '/addjournalentry'
  //       // }
  //     ],
  //   },
  //   // {
  //   //   menu: 'crdrNote',
  //   //   title: 'Debit / Credit Note',
  //   //   mainNav: '/alldebitnote',
  //   //   subNav: '',
  //   //   tooltip: 'Add Debit Note',
  //   //   toolTipMain: "View Debit Note List",
  //   //   icon: <Avatar variant="rounded" sx={{ color: selector === 'customer' ? 'sideBar.secondary' : '#ffffff', fontSize: '12px', fontWeight: 'bold', backgroundColor: selector === "crdrNote" ? "sideBar.main" : 'rgb(255 255 255 / 20%)',boxShadow: selectorIcon("/") ? "" : "0px 6px 8px rgba(0, 0, 0, 0.5)",backgroundColor:'rgb(255 255 255 / 20%)', borderRadius: '3px', height: '30px', width: '30px' }}>Dcn</Avatar>,
  //   //   submenus: [
  //   //   ]
  //   // },
  //   {
  //     menu: "openingBalance",
  //     title: "Opening Balance",
  //     mainNav: "/openingbalance",
  //     subNav: "/openingbalance",
  //     tooltip: "Opening Balance",
  //     toolTipMain: "View Opening Balance List",
  //     icon: (
  //       <Avatar
  //         variant="rounded"
  //         sx={{
  //           color:
  //             selector == "openingBalance" ? "sideBar.secondary" : "#ffffff",
  //           fontSize: "12px",
  //           fontWeight: "bold",
  //           // backgroundColor:selectorIcon("openingbalance") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
  //           boxShadow: selectorIcon("openingbalance")
  //             ? ""
  //             : "0px 6px 8px rgba(0, 0, 0, 0.5)",
  //           backgroundColor: "rgb(255 255 255 / 20%)",
  //           borderRadius: "3px",
  //           height: "30px",
  //           width: "30px",
  //         }}
  //       >
  //         OpB
  //       </Avatar>
  //     ),
  //     submenus: [],
  //   },
  //   {
  //     menu: "accounts",
  //     title: "Accounts",
  //     mainNav: "/accounts",
  //     toolTipMain: "View Accounts ",
  //     // subNav: '',
  //     tooltip: "",
  //     icon: (
  //       <Avatar
  //         variant="rounded"
  //         sx={{
  //           color: selector == "accounts" ? "sideBar.secondary" : "#ffffff",
  //           fontSize: "12px",
  //           fontWeight: "bold",
  //           // backgroundColor: selectorIcon("accounts") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
  //           boxShadow: selectorIcon("accounts")
  //             ? ""
  //             : "0px 6px 8px rgba(0, 0, 0, 0.5)",
  //           backgroundColor: "rgb(255 255 255 / 20%)",
  //           borderRadius: "3px",
  //           height: "30px",
  //           width: "30px",
  //         }}
  //       >
  //         Acc
  //       </Avatar>
  //     ),
  //     submenus: [],
  //   },
  //   {
  //     menu: "reports",
  //     title: "Reports",
  //     mainNav: "/reports",
  //     // subNav: '',
  //     tooltip: "",
  //     toolTipMain: "View Reports",
  //     icon: (
  //       <Avatar
  //         variant="rounded"
  //         sx={{
  //           color: selector === "reports" ? "sideBar.secondary" : "#ffffff",
  //           fontSize: "12px",
  //           fontWeight: "bold",
  //           // backgroundColor: selectorIcon("reports") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
  //           boxShadow: selectorIcon("reports")
  //             ? ""
  //             : "0px 6px 8px rgba(0, 0, 0, 0.5)",
  //           backgroundColor: "rgb(255 255 255 / 20%)",
  //           borderRadius: "3px",
  //           height: "30px",
  //           width: "30px",
  //         }}
  //       >
  //         Rpt
  //       </Avatar>
  //     ),
  //     submenus: [],
  //   },
  //   // {
  //   //   menu: "Support",
  //   //   title: "Support",
  //   //   mainNav: "/supportpage",
  //   //   // subNav: '',
  //   //   tooltip: "",
  //   //   toolTipMain: "Support",
  //   //   icon: (
  //   //     <Avatar
  //   //       variant="rounded"
  //   //       sx={{
  //   //         color: selector === "Support" ? "sideBar.secondary" : "#ffffff",
  //   //         fontSize: "12px",
  //   //         fontWeight: "bold",
  //   //         // backgroundColor: selectorIcon("reports") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
  //   //         boxShadow: selectorIcon("Support")
  //   //           ? ""
  //   //           : "0px 6px 8px rgba(0, 0, 0, 0.5)",
  //   //         backgroundColor: "rgb(255 255 255 / 20%)",
  //   //         borderRadius: "3px",
  //   //         height: "30px",
  //   //         width: "30px",
  //   //       }}
  //   //     >
  //   //       Spt
  //   //     </Avatar>
  //   //   ),
  //   //   submenus: [],
  //   // },
  //   // {
  //   //   menu: "Settings",
  //   //   title: "Settings",
  //   //   // mainNav: "/supportpage",
  //   //   // subNav: '',
  //   //   tooltip: "",
  //   //   onclick: () => dispatch(displaySettings()),
  //   //   toolTipMain: "Settings",
  //   //   icon: (
  //   //     <Avatar
  //   //       variant="rounded"
  //   //       sx={{
  //   //         color: selector === "Settings" ? "sideBar.secondary" : "#ffffff",
  //   //         fontSize: "12px",
  //   //         fontWeight: "bold",
  //   //         // backgroundColor: selectorIcon("reports") ? "sideBar.main" : 'rgb(255 255 255 / 20%)',
  //   //         boxShadow: selectorIcon("Settings")
  //   //           ? ""
  //   //           : "0px 6px 8px rgba(0, 0, 0, 0.5)",
  //   //         backgroundColor: "rgb(255 255 255 / 20%)",
  //   //         borderRadius: "3px",
  //   //         height: "30px",
  //   //         width: "30px",
  //   //       }}
  //   //     >
  //   //       Set
  //   //     </Avatar>
  //   //   ),
  //   //   submenus: [],
  //   // },
  // ];

  const handleChange = (name) => {
    let obj = {};
    for (const key in state.openMenu) {
      if (key !== name) {
        obj[key] = false;
      }
    }

    setState((prev) => ({
      ...prev,
      selectMenu: name,
      // openMenu:{
      //     ...prev.openMenu,
      //     [name] : !(state.openMenu[name])
      // }
      openMenu: {
        ...obj,
        [name]: !state.openMenu[name],
      },
    }));
  };
  const [sidebarOpen, setSidebarOpen] = useState();
  const [sidebarOpenDwn, setSidebarOpenDwn] = useState(false);
  const [pin, setPin] = useState();
  // console.log(sidebarOpen, "sidebarOpen");
  // const [expandIcon, setExpandIcon] = useState(false);
  const handleExpandButtonClick = () => {
    if (!sidebarOpen) {
      setSidebarOpen(!sidebarOpen);
    } else {
      setSidebarOpen(!sidebarOpen);
      setState({
        selectMenu: "",
        selectSubMenu: "",
        openMenu: {
          dashboard: false,
          inventory: false,
          customer: false,
          purchase: false,
          sales: false,
          payments: false,
          receipts: false,
          accounts: false,
          reports: false,
          journalentries: false,
        },
      });
    }
  };
  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);

  async function FirstFn() {
    try {
      // const r = await API.graphql(
      //   graphqlOperation(getSideBarUserPreference, { financialyearid: 1 })
      // );
      const res = await API.graphql(graphqlOperation(listUserPreference));
      let value = res.data.listUserPreference.find(
        (e) => e.attributetypecd === "SideBarPin"
      )?.attributevalue;
      // let value = r.data.getSideBarUserPreference?.attributevalue;
      setPin(value === undefined ? true : value == 0 ? true : false);
      setSidebarOpen(value === undefined ? true : false);
    } catch (e) {
      console.log(e, "error");
    }
  }
  useEffect(() => {
    FirstFn();
  }, []);

  const pinFn = () => {
    API.graphql(
      graphqlOperation(createUserPreference, {
        createUserPreferenceInput: {
          attributetypecd: "SideBarPin",
          attributevalue: pin ? 1 : 0,
          additionalvalue: "",
        },
      })
    )
      .then((r) => {})
      .catch((e) => {
        console.log(e, "error");
      });
  };
  const inputRef = useRef(null);
  useEffect(() => {
    if (sidebarOpen) {
      inputRef?.current?.focus();
      inputRef?.current?.blur();
    } else {
      setState((prev) => ({
        ...prev,
        selectMenu: "",
      }));
      inputRef?.current?.blur();
    }
  }, [sidebarOpen]);
  return (
    <Box
      sx={{
        scale: "0.85",
        left: "0",
        top: "70px",
        position: "fixed",
        zIndex: 999,
        "@media (min-width:1000px) and (max-width:1050px)":{
          top: "50px",
        }
      }}
    >
      <SlidbarBox
        theme={theme}
        isExpanded={sidebarOpen}
        onMouseLeave={() => {
          setSubMenuOpen(false);
          setSidebarOpen(false);
          setState({
            selectMenu: "",
            selectSubMenu: "",
            openMenu: {
              dashboard: false,
              inventory: false,
              customer: false,
              purchase: false,
              sales: false,
              payments: false,
              receipts: false,
              accounts: false,
              reports: false,
              journalentries: false,
            },
          });
        }}
      >
        <Tooltip
          title={"Click Here to Expand/Collapse the Menu"}
          placement="top"
          arrow
        >
          {/* <SwapHorizontalCircleSharpIcon onClick={() => handleExpandButtonClick()} style={{ backgroundColor: 'primary.main', color: '#fff', textAlign: 'center', padding: '3px 10px', fontSize: '25px',transition:"transform 0.3s ease", transform: expandIcon ? "rotate(180deg)" : "rotate(0deg)" }} /> */}
          <Box
            onClick={() => {
              // handleExpandButtonClick()
              pinFn();
              setPin(!pin);
              if (pin) {
                setSidebarOpen(false);
              }
            }}
            sx={{
              background: "primary.main",
              // borderBottom: !sidebarOpen ? "1px solid" : "none",
              color: "#fff",
              textAlign: "center",
              padding: "3px 10px",
              fontSize: "10px",
              transition: "transform 0.75s ease",
              transform: sidebarOpen
                ? "rotate(360deg)  translate(100px, 0px) rotateY(180deg)"
                : "rotate(0deg) translate(0, 0) rotateY(0deg)",
            }}
          >
            <button
              ref={inputRef}
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              style={{
                color: "white",
                background: "transparent",
                border: "0",
                padding: 0,
                margin: 0,
                outline: "none",
                "&:focus": {
                  outline: "none", // Removes the default outline
                },
              }}
            >
              <PushPin
                sx={{
                  transition: "transform 0.5s ease",
                  transform: pin
                    ? !sidebarOpen
                      ? "rotate(45deg)"
                      : "rotate(315deg)"
                    : "rotate(0deg)",
                }}
              />
            </button>
          </Box>
          {/* {sidebarOpen ?
          (<ArrowCircleLeft  style={{
            backgroundColor: 'primary.main', color: '#fff', textAlign: 'center', padding: '3px 10px', fontSize: '25px', transition: "transform 0.9s ease",
            transform: sidebarOpen
              ? 'rotate(0deg) translate(180px, 0)'
              : 'rotate(180deg) translate(220px, 0px)',
          }} />):
        } */}
        </Tooltip>
        {menus.map((item, ind) => {
          return (
            <Box
              sx={{ borderTop: ind === 0 ? "1px solid white" : "none" }}
              onMouseOver={() => {
                if (pin) {
                  setSidebarOpen(true);
                }
              }}
              onClick={() => (item.onclick ? item.onclick() : null)}
              key={ind}
            >
              <Box
                className="boxes"
                onClick={() => {
                  // setselector(item.menu)
                  if (item.menu === "purchase" || item.menu === "sales") {
                    // setSidebarOpen(true)
                  }
                  if (state.selectMenu !== item.menu) {
                    setSubMenuOpen(item.menu);
                    handleChange(item.menu);
                  }
                  if (state.selectMenu === item.menu) {
                    setSubMenuOpen("");
                    setState((prev) => ({
                      ...prev,
                      selectMenu: "",
                    }));
                  }
                }}
              >
                <Box className="icon_box">
                  <Tooltip
                    title={item?.toolTipMain}
                    placement="right"
                    disableInteractive
                    arrow
                  >
                    <Link
                      id={item?.subNav}
                      tabIndex={-1}
                      to={item.mainNav}
                      style={{ textDecoration: "none" }}
                      onClick={(e) => {
                        if (item.mainNav == undefined) {
                          e.preventDefault();
                        }
                      }}
                    >
                      {item.icon}
                    </Link>
                  </Tooltip>
                </Box>

                {item?.submenus?.length === 0 ? (
                  <Link
                    id={item.subNav}
                    to={item.subNav}
                    style={{ textDecoration: "none" }}
                    onClick={(e) => {
                      if (item.subNavDisabled) {
                        handleFreeze();
                        e.preventDefault();
                      }
                      if (saveSkipStatus == false) {
                        if (window.location.href.includes("companysetup")) {
                          showWarningSnackbar(
                            "Please Complete the Company Setup Details"
                          );
                        }
                        e.preventDefault();
                        dispatch(settingsClose());
                        navigate("/companysetup");
                      }
                      e.stopPropagation();
                    }}
                  >
                    <Box
                      className="SubNav_box"
                      id={item.subNav}
                      sx={{
                        display: item.subNav !== undefined ? "flex" : "none",
                        // justifyContent: "center",
                        // // borderRadius:  "0 7px 7px 0",
                        // borderTopRightRadius: ind === 1 ? "7px" : "0px",
                        // borderBottomRightRadius: ind === 8 ? "7px" : "0px",
                        cursor: "pointer",
                        "&:hover": {
                          // backgroundColor: 'lightgray', // Change to your desired hover background color
                        },
                      }}
                    >
                      {/* <AddBoxIcon id="add_pages" sx={{
                      color: theme.palette.primary.main,
                      // boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.5)",
                      background: "transparant",
                      fontSize: "1.25rem",
                    }} /> */}
                      <Tooltip
                        title={item?.tooltip}
                        placement="right"
                        disableInteractive
                        arrow
                      >
                        <IconButton
                          disableRipple={false}
                          className="AddIcon"
                          centerRipple
                          sx={{
                            // background: theme.palette.primary.main,
                            color: item.submenuColor,
                            background: "transparent",
                            // boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.5)",
                            position: "relative",
                            top: "30%",
                            left: "41%",
                            transform: "translate(-50%,-50%)",
                            width: "25px",
                            height: "25px",
                            // color: "white",
                            borderRadius: "2px",
                            "&::after": {
                              content: '""',
                              position: "absolute",
                              width: "100%",
                              height: "100%",
                              top: 0,
                              left: 0,
                              backgroundColor: item.submenuColor, // Change to your desired ripple color
                              borderRadius: "50%",
                              transform: "scale(0)",
                              transition: "transform 0.3s, opacity 0.3s",
                              opacity: 0,
                            },
                            "&:hover::after": {
                              transform: "scale(1)",
                              opacity: 0.5,
                            },
                            "&:hover::after.icon_box": {
                              background: "#fff",
                            },
                          }}
                        >
                          <AddIcon id={item.subNav}/>
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Link>
                ) : (
                  <Box>
                    <Box
                      className="SubNav_box"
                      id={item.subNav}
                      sx={{
                        // borderRadius: "0 7px 7px 0",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (state.selectMenu === item.menu) {
                          setState((prev) => ({
                            ...prev,
                            selectMenu: "",
                          }));
                        }
                        setSidebarOpenDwn(true);
                      }}
                      onMouseLeave={() => {
                        setSubMenuOpen("");
                        setSidebarOpenDwn(false);
                      }}
                      onMouseOver={() => {
                        setSubMenuOpen(
                          state.selectMenu === item.menu &&
                            state.openMenu[item.menu]
                            ? item.menu
                            : ""
                        );
                      }}
                    >
                      <ExpandToolTip title={`expands`} placement="right">
                        <KeyboardArrowDownIcon
                          sx={{
                            // background: theme.palette.primary.main,
                            // boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.5)",
                            color: theme.palette.primary.main,
                            background: "transparent",
                            position: "relative",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%,-50%)",
                            width: "25px",
                            height: "25px",
                            // color: "white",
                            borderRadius: "2px",
                          }}
                        />
                      </ExpandToolTip>
                    </Box>
                  </Box>
                )}

                <Box className="text_box">
                  <Tooltip
                    title={item?.toolTipMain}
                    placement="right"
                    disableInteractive
                    arrow
                  >
                    {item?.mainNav?.length ? (
                      <Link
                        tabIndex={-1}
                        k
                        to={item.mainNav}
                        style={{ textDecoration: "none" }}
                      >
                        <Typography
                          className="text"
                          sx={{
                            color:
                              state.openMenu[item.menu] &&
                              state.selectMenu == item.menu
                                ? "#fff"
                                : "#fff",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                          // onClick={() => {
                          //   navigate(item.mainNav);
                          // }}
                        >
                          {item.title}
                        </Typography>
                      </Link>
                    ) : (
                      <div to={item.mainNav} style={{ textDecoration: "none" }}>
                        <Typography
                          className="text"
                          sx={{
                            color:
                              state.openMenu[item.menu] &&
                              state.selectMenu == item.menu
                                ? "#fff"
                                : "#fff",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                          // onClick={() => {
                          //   navigate(item.mainNav);
                          // }}
                        >
                          {item.title}
                        </Typography>
                      </div>
                    )}
                  </Tooltip>
                  {/* { item.submenus.length > 0 &&
                  (state.openMenu[item.menu] ? (
                    <ExpandLess
                      className="toggle_icon"
                      sx={{ color: "#fff", fontSize: "21px", marginRight: 1 }}
                    />
                  ) : (
                    <ExpandMore
                      className="toggle_icon"
                      sx={{ color: "#fff", fontSize: "21px", marginRight: 1 }}
                    />
                  ))
                } */}

                  {item?.subNav?.length > 0 ? (
                    <Tooltip title={item?.tooltip} placement="right" arrow>
                      <Link
                        tabIndex={-1}
                        to={item.subNav}
                        // to={`${item.subNav === "/addcustomer" ? `${item.subNav}?value=${location.pathname}` : `${item.subNav}`}`}
                        // target='_blank'
                        style={{ height: "20px", textDecoration: "none" }}
                        onClick={(e) => {
                          if (item.subNavDisabled) {
                            handleFreeze();
                            e.preventDefault();
                          }
                          if (saveSkipStatus == false) {
                            if (window.location.href.includes("companysetup")) {
                              showWarningSnackbar(
                                "Please Complete the Company Setup Details"
                              );
                            }
                            e.preventDefault();
                            dispatch(settingsClose());
                            navigate("/companysetup");
                          }
                        }}
                      >
                        {/* <AddBoxIcon
                        fontSize="small"
                        sx={{
                          color: "#fff",
                          marginRight: "15px",
                          cursor: "pointer",
                        }}
                      /> */}
                        <AddIcon
                          sx={{
                            // background: theme.palette.primary.main,
                            background: "transparent",
                            // boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.5)",
                            position: "relative",
                            top: "65%",
                            left: "5%",
                            transform: "translate(-50%,-50%)",
                            width: "25px",
                            height: "25px",
                            color: "white",
                            borderRadius: "2px",
                          }}
                        />
                      </Link>
                    </Tooltip>
                  ) : item?.submenus.length ? (
                    <>
                      {state.openMenu[item.menu] &&
                      item?.submenus?.length > 0 ? (
                        <KeyboardArrowUpIcon
                          fontSize="small"
                          sx={{
                            color: "white",
                            marginRight: "15px",
                            cursor: "pointer",
                          }}
                        />
                      ) : (
                        <KeyboardArrowDownIcon
                          fontSize="small"
                          sx={{
                            color: "#fff",
                            marginRight: "15px",
                            cursor: "pointer",
                          }}
                        />
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </Box>
              </Box>
              <Collapse
                in={
                  subMenuOpen == item.menu
                    ? true
                    : state.selectMenu === item.menu &&
                      state.openMenu[item.menu]
                }
                timeout="auto"
                unmountOnExit
              >
                <Box>
                  {item.submenus.map((submenu, index) => {
                    return submenu.tab ? (
                      <Box key={index} className="collapse_boxes">
                        {/* {index === 0 && <Divider sx={{ background: "black" }} />} */}
                        <Link
                          to={submenu.nav}
                          id="navigate05"
                          className="collapse_empty"
                          style={{ textDecoration: "none" }}
                          sx={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            console.log("disabled", submenu.subNavDisabled);
                            if (submenu.navDisabled) {
                              handleFreeze();
                              e.preventDefault();
                            }
                            // navigate(submenu.nav);
                          }}
                        >
                          <Tooltip
                            title={submenu?.tooltipMain}
                            placement="right"
                            disableInteractive
                            arrow
                          >
                            {submenu.icon}
                          </Tooltip>
                          <Collapse
                            in={
                              subMenuOpen == item.menu
                                ? true
                                : state.selectMenu === item.menu &&
                                  state.openMenu[item.menu]
                            }
                            timeout="auto"
                            unmountOnExit
                          >
                            <Box
                              className="add_sub_pages"
                              onMouseLeave={() => {
                                setSubMenuOpen("");
                              }}
                              onMouseOver={() => {
                                setSubMenuOpen(item.menu);
                              }}
                              sx={{
                                position: "fixed",
                                // display: (submenu.subNav && !sidebarOpen) ? "flex" : "none",
                                width: "35px",
                                height: "40px",
                                // display:
                                //   state.selectMenu === item.menu &&
                                //     state.openMenu[item.menu]
                                //     ? "flex"
                                //     : "none",
                                // background: ` ${theme.palette.primary.main}29`,
                                mt: "-15px",
                                left: "50px",
                                display: "flex",
                                justifyContent: "center",
                                // alignItems: "center",
                                cursor: "pointer",
                              }}
                              onClick={(e) => {
                                if (!sidebarOpen) {
                                  e.stopPropagation();
                                }
                              }}
                            >
                              <Link
                                id="navigate01"
                                to={submenu.subNav}
                                onClick={(e) => {
                                  console.log(
                                    "disabled",
                                    submenu.subNavDisabled
                                  );
                                  if (submenu.subNavDisabled) {
                                    handleFreeze();
                                    e.preventDefault();
                                  }
                                  // navigate(submenu.nav);
                                  if (saveSkipStatus == false) {
                                    if (
                                      window.location.href.includes(
                                        "companysetup"
                                      )
                                    ) {
                                      showWarningSnackbar(
                                        "Please Complete the Company Setup Details"
                                      );
                                    }
                                    e.preventDefault();
                                    dispatch(settingsClose());
                                    navigate("/companysetup");
                                  }
                                }}
                                style={{
                                  display:
                                    submenu.subNav && !sidebarOpen
                                      ? "flex"
                                      : "none",
                                  textDecoration: "none",
                                }}
                              >
                                {/* <AddBoxIcon
                              id="add_pages"
                              sx={{
                                // color: theme.palette.primary.main,
                                color:
                                  submenu.name === "Recurring Invoices"
                                    ? "#b5b5b5"
                                    : theme.palette.primary.main,
                                fontSize: "1.25rem",
                                display:
                                  state.selectMenu === item.menu &&
                                    state.openMenu[item.menu] &&
                                    !sidebarOpen
                                    ? "flex"
                                    : "none",
                              }}
                            /> */}
                                <Tooltip
                                  title={submenu?.tooltip}
                                  placement="right"
                                  disableInteractive
                                  arrow
                                >
                                  <IconButton
                                    disableRipple={false}
                                    className="AddIcon"
                                    centerRipple
                                    sx={{
                                      // background: theme.palette.primary.main,
                                      color: theme.palette.primary.main,
                                      background: "transparent",
                                      // boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.5)",
                                      position: "relative",
                                      top: "40%",
                                      left: "41%",
                                      transform: "translate(-50%,-50%)",
                                      width: "25px",
                                      height: "25px",
                                      // color: "white",
                                      borderRadius: "2px",
                                      "&::after": {
                                        content: '""',
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        top: 0,
                                        left: 0,
                                        backgroundColor:
                                          theme.palette.secondary.main, // Change to your desired ripple color
                                        borderRadius: "50%",
                                        transform: "scale(0)",
                                        transition:
                                          "transform 0.3s, opacity 0.3s",
                                        opacity: 0,
                                      },
                                      "&:hover::after": {
                                        transform: "scale(1)",
                                        opacity: 0.5,
                                      },
                                      "&:hover::after.icon_box": {
                                        background: "#fff",
                                      },
                                    }}
                                  >
                                    <AddIcon id={item.subNav} />
                                  </IconButton>
                                </Tooltip>
                              </Link>
                            </Box>
                          </Collapse>
                        </Link>

                        <Box
                          className="collapse_text p-0"
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "0px",
                          }}
                        >
                          {/* <Avatar children={''} sx={{ width: 6, height: 6,color:'#fff'}}></Avatar> */}
                          <Tooltip
                            title={submenu?.tooltipMain}
                            placement="right"
                            hidden={submenu?.tooltip.length ? false : true}
                            disableInteractive
                            arrow
                          >
                            <Link
                              id="navigate02"
                              tabIndex={-1}
                              onClick={(e) => {
                                setState((prev) => ({
                                  ...prev,
                                  selectSubMenu: submenu.name,
                                }));
                              }}
                              style={{ textDecoration: "none" }}
                              to={submenu.nav}
                              // target='_blank'
                            >
                              <Typography
                                className="submenu_text"
                                sx={{
                                  paddingLeft: "4.5px",
                                  color:
                                    state.selectSubMenu == submenu.name
                                      ? "#fff"
                                      : "#fff",
                                  fontSize: "12px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {submenu.name}
                              </Typography>
                            </Link>
                          </Tooltip>
                          {submenu?.subNav?.length > 0 &&
                            (submenu?.newTab ? (
                              <Tooltip
                                title={submenu?.tooltip}
                                placement="right"
                                arrow
                              >
                                <Link
                                  style={{ textDecoration: "none" }}
                                  id="navigate03"
                                  tabIndex={-1}
                                  to={submenu.subNav}
                                  target="_blank"
                                  onClick={(e) => {
                                    if (saveSkipStatus == false) {
                                      if (
                                        window.location.href.includes(
                                          "companysetup"
                                        )
                                      ) {
                                        showWarningSnackbar(
                                          "Please Complete the Company Setup Details"
                                        );
                                      }
                                      e.preventDefault();
                                      dispatch(settingsClose());
                                      navigate("/companysetup");
                                    }
                                  }}
                                >
                                  {/* <AddBoxIcon
                                fontSize="small"
                                sx={{
                                  color: "#fff",
                                  marginRight: "15px",
                                  cursor: "pointer",
                                }}
                              /> */}
                                  <AddIcon
                                    sx={{
                                      // background: theme.palette.primary.main,
                                      background: "transparent",
                                      // boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.5)",
                                      position: "relative",
                                      top: "70%",
                                      left: "6%",
                                      transform: "translate(-50%,-50%)",
                                      width: "25px",
                                      height: "25px",
                                      color: "white",
                                      borderRadius: "2px",
                                    }}
                                  />
                                </Link>
                              </Tooltip>
                            ) : (
                              <>
                                {/* <Button>Arrow</Button> */}
                                {/* <AddBoxIcon
                              fontSize="small"
                              sx={{
                                color: "#fff",
                                cursor: "pointer",
                                marginRight: "10px !important",
                              }}
                              onClick={() => {
                                dispatch(nonGst());
                                navigate(submenu.subNav, {
                                  state: { add: true },
                                });
                              }}
                            /> */}
                                <Link
                                  id="navigate04"
                                  onClick={(e) => {
                                    // e.preventDefault()

                                    if (submenu.subNavDisabled) {
                                      handleFreeze();
                                      e.preventDefault();
                                    }
                                    if (saveSkipStatus == false) {
                                      dispatch(settingsClose());
                                      navigate("/companysetup");
                                    } else {
                                      dispatch(nonGst());
                                      // navigate(submenu.subNav, {
                                      //   state: { add: true },
                                      // });
                                    }
                                  }}
                                  style={{
                                    position: "relative",
                                    top: "45%",
                                    left: "11%",
                                    textDecoration: "none",
                                  }}
                                  to={submenu.subNav}
                                >
                                  <Tooltip
                                    title={submenu?.tooltip}
                                    disableInteractive
                                    placement="right"
                                    arrow
                                  >
                                    <AddIcon
                                      sx={{
                                        // background: theme.palette.primary.main,
                                        background: "transparent",
                                        transform: "translate(-50%,-50%)",
                                        width: "25px",
                                        height: "25px",
                                        color: "white",
                                        cursor: "pointer",
                                        borderRadius: "2px",
                                      }}
                                    />
                                  </Tooltip>
                                </Link>
                              </>
                            ))}
                        </Box>
                        {/* {index === item.submenus.length - 1 && <Divider sx={{ background: "black" }} />} */}
                      </Box>
                    ) : (
                      <Box
                        key={index}
                        className="collapse_boxes"
                        onClick={() => {
                          // navigate(submenu.nav);
                          setState((prev) => ({
                            ...prev,
                            selectSubMenu: submenu.name,
                          }));
                        }}
                      >
                        <Box className="collapse_empty"></Box>
                        <Box className="collapse_text">
                          {/* <Avatar children={''} sx={{ width: 6, height: 6,color:'#fff'}}></Avatar> */}
                          <Tooltip
                            title={submenu?.tooltipMain}
                            placement="right"
                            hidden={submenu?.tooltip.length ? false : true}
                            disableInteractive
                            arrow
                          >
                            <Typography
                              className="submenu_text"
                              sx={{
                                paddingLeft: "10px",
                                color:
                                  state.selectSubMenu == submenu.name
                                    ? "#fff"
                                    : "#fff",
                                fontSize: "14px",
                              }}
                            >
                              {submenu.name}
                            </Typography>
                          </Tooltip>
                        </Box>
                      </Box>
                    );

                    {
                      /* return <Box
                                key={index}
                                className='collapse_boxes'
                                onClick={()=> {
                                    navigate(submenu.nav);
                                    setState( prev => ({
                                        ...prev,
                                        selectSubMenu:submenu.name
                                    }))
                                }}
                              >
                                  <Box className='collapse_empty'></Box>
                                  <Box className='collapse_text'>
                                      <Avatar children={''} sx={{ width: 6, height: 6,color:'#fff'}}></Avatar>
                                      <Typography className='submenu_text' sx={{paddingLeft:'10px',color:state.selectSubMenu==submenu.name ? '#fff' : '#fff',fontSize:'14px'}}>{submenu.name}</Typography>
                                  </Box>
                              </Box> */
                    }
                  })}
                </Box>
              </Collapse>
            </Box>
          );
        })}
      </SlidbarBox>
    </Box>
  );
}

export default Sidebar;
